/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';

import { Observable } from "rxjs/Observable";

import { Menu } from '@api/models/menu';
import { User } from '@api/models/user';

/**
 * Service to get and manage the menu
 */
@Injectable()
export abstract class MenuService {

    /**
     * Return menu from backend and translate it into the array of Menus
     * @param user The authenticated user 
     */
    abstract getMenus(user: User): Observable<Menu[]> ;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/services/menu.service.ts